import PaymentsHistory from "../../PaymentsHistory";
import TabsComponent from "../../components/Tabs/Tabs";
import Plans from "../../components/plans";
import { useTranslation } from "react-i18next";

const routes = ["buy", "history"];

export default function RootCMDS(props: any) {
  const { t } = useTranslation();
  const checkType = (type: "buy" | "history") => (type === "buy" ? 0 : 1);
  const currentTab = checkType(props.match.params.type);

  return (
    <TabsComponent
      value={currentTab}
      tabs={[
        {
          label: t("cmds.buy"),
          contentBody: <Plans />
        },
        {
          label: t("cmds.purchasesHistory"),
          contentBody: <PaymentsHistory />
        }
      ]}
      handleChange={e => props.history.push(`/cmds/${routes[e]}`)}
    />
  );
}
